import { gql } from '@edreamsodigeo/frontend-api-client';

export const ADD_PROMOCODE_TO_SHOPPING_BASKET = gql`
  mutation SB_AddPromoCodeToUniversalShoppingBasket(
    $request: AddUniversalShoppingBasketPromoCodeRequest!
  ) {
    addPromoCodeToUniversalShoppingBasket(request: $request) {
      success
    }
  }
`;

export const REMOVE_PROMOCODE_FROM_SHOPPING_BASKET = gql`
  mutation SB_RemovePromoCodeFromUniversalShoppingBasket(
    $request: RemoveUniversalShoppingBasketPromoCodeRequest!
  ) {
    removePromoCodeFromUniversalShoppingBasket(request: $request) {
      success
    }
  }
`;
